//* 将模型名称转义成符合HTML规范的字符串
export default (context: string): string => {
    //* 数据初始化
    const config = { result: context };
    //* 上标解析
    if (config.result.includes("<") && config.result.includes(">")) {
        config.result = config.result.replaceAll(/[\<\>]/g, (value: string) => {
            switch (value) {
                case "<":
                    return "<sup>";
                case ">":
                    return "</sup>";
                default:
                    return "";
            }
        });
    }

    //* 斜体解析
    if (config.result.includes("[") && config.result.includes("]")) {
        config.result = config.result.replaceAll(/[\[\]]/g, (value: string) => {
            switch (value) {
                case "[":
                    return "<em>";
                case "]":
                    return "</em>";
                default:
                    return "";
            }
        });
    }

    return config.result;
};
